function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, l) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = l() : "function" == typeof define && define.amd ? define([], l) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Table = l() : e.Table = l();
}(window, function () {
  return function (e) {
    var l = {};

    function a(_) {
      if (l[_]) return l[_].exports;
      var t = l[_] = {
        i: _,
        l: !1,
        exports: {}
      };
      return e[_].call(t.exports, t, t.exports, a), t.l = !0, t.exports;
    }

    return a.m = e, a.c = l, a.d = function (e, l, _) {
      a.o(e, l) || Object.defineProperty(e, l, {
        enumerable: !0,
        get: _
      });
    }, a.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, a.t = function (e, l) {
      if (1 & l && (e = a(e)), 8 & l) return e;
      if (4 & l && "object" == _typeof(e) && e && e.__esModule) return e;

      var _ = Object.create(null);

      if (a.r(_), Object.defineProperty(_, "default", {
        enumerable: !0,
        value: e
      }), 2 & l && "string" != typeof e) for (var t in e) {
        a.d(_, t, function (l) {
          return e[l];
        }.bind(null, t));
      }
      return _;
    }, a.n = function (e) {
      var l = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return a.d(l, "a", l), l;
    }, a.o = function (e, l) {
      return Object.prototype.hasOwnProperty.call(e, l);
    }, a.p = "", a(a.s = 2);
  }([function (e, l) {
    e.exports = function (e) {
      var l = [];
      return l.toString = function () {
        return this.map(function (l) {
          var a = function (e, l) {
            var a = e[1] || "",
                _ = e[3];
            if (!_) return a;

            if (l && "function" == typeof btoa) {
              var t = (o = _, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */"),
                  r = _.sources.map(function (e) {
                return "/*# sourceURL=" + _.sourceRoot + e + " */";
              });

              return [a].concat(r).concat([t]).join("\n");
            }

            var o;
            return [a].join("\n");
          }(l, e);

          return l[2] ? "@media " + l[2] + "{" + a + "}" : a;
        }).join("");
      }, l.i = function (e, a) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var _ = {}, t = 0; t < this.length; t++) {
          var r = this[t][0];
          "number" == typeof r && (_[r] = !0);
        }

        for (t = 0; t < e.length; t++) {
          var o = e[t];
          "number" == typeof o[0] && _[o[0]] || (a && !o[2] ? o[2] = a : a && (o[2] = "(" + o[2] + ") and (" + a + ")"), l.push(o));
        }
      }, l;
    };
  }, function (e, l, a) {
    var _,
        t,
        r = {},
        o = (_ = function _() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === t && (t = _.apply(this, arguments)), t;
    }),
        s = function s(e, l) {
      return l ? l.querySelector(e) : document.querySelector(e);
    },
        c = function (e) {
      var l = {};
      return function (e, a) {
        if ("function" == typeof e) return e();

        if (void 0 === l[e]) {
          var _ = s.call(this, e, a);

          if (window.HTMLIFrameElement && _ instanceof window.HTMLIFrameElement) try {
            _ = _.contentDocument.head;
          } catch (e) {
            _ = null;
          }
          l[e] = _;
        }

        return l[e];
      };
    }(),
        d = null,
        h = 0,
        n = [],
        i = a(5);

    function v(e, l) {
      for (var a = 0; a < e.length; a++) {
        var _ = e[a],
            t = r[_.id];

        if (t) {
          t.refs++;

          for (var o = 0; o < t.parts.length; o++) {
            t.parts[o](_.parts[o]);
          }

          for (; o < _.parts.length; o++) {
            t.parts.push(b(_.parts[o], l));
          }
        } else {
          var s = [];

          for (o = 0; o < _.parts.length; o++) {
            s.push(b(_.parts[o], l));
          }

          r[_.id] = {
            id: _.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function w(e, l) {
      for (var a = [], _ = {}, t = 0; t < e.length; t++) {
        var r = e[t],
            o = l.base ? r[0] + l.base : r[0],
            s = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        _[o] ? _[o].parts.push(s) : a.push(_[o] = {
          id: o,
          parts: [s]
        });
      }

      return a;
    }

    function C(e, l) {
      var a = c(e.insertInto);
      if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var _ = n[n.length - 1];
      if ("top" === e.insertAt) _ ? _.nextSibling ? a.insertBefore(l, _.nextSibling) : a.appendChild(l) : a.insertBefore(l, a.firstChild), n.push(l);else if ("bottom" === e.insertAt) a.appendChild(l);else {
        if ("object" != _typeof(e.insertAt) || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var t = c(e.insertAt.before, a);
        a.insertBefore(l, t);
      }
    }

    function u(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var l = n.indexOf(e);
      l >= 0 && n.splice(l, 1);
    }

    function f(e) {
      var l = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var _ = function () {
          0;
          return a.nc;
        }();

        _ && (e.attrs.nonce = _);
      }

      return p(l, e.attrs), C(e, l), l;
    }

    function p(e, l) {
      Object.keys(l).forEach(function (a) {
        e.setAttribute(a, l[a]);
      });
    }

    function b(e, l) {
      var a, _, t, r;

      if (l.transform && e.css) {
        if (!(r = "function" == typeof l.transform ? l.transform(e.css) : l.transform["default"](e.css))) return function () {};
        e.css = r;
      }

      if (l.singleton) {
        var o = h++;
        a = d || (d = f(l)), _ = y.bind(null, a, o, !1), t = y.bind(null, a, o, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (a = function (e) {
        var l = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", p(l, e.attrs), C(e, l), l;
      }(l), _ = M.bind(null, a, l), t = function t() {
        u(a), a.href && URL.revokeObjectURL(a.href);
      }) : (a = f(l), _ = x.bind(null, a), t = function t() {
        u(a);
      });

      return _(e), function (l) {
        if (l) {
          if (l.css === e.css && l.media === e.media && l.sourceMap === e.sourceMap) return;

          _(e = l);
        } else t();
      };
    }

    e.exports = function (e, l) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
      (l = l || {}).attrs = "object" == _typeof(l.attrs) ? l.attrs : {}, l.singleton || "boolean" == typeof l.singleton || (l.singleton = o()), l.insertInto || (l.insertInto = "head"), l.insertAt || (l.insertAt = "bottom");
      var a = w(e, l);
      return v(a, l), function (e) {
        for (var _ = [], t = 0; t < a.length; t++) {
          var o = a[t];
          (s = r[o.id]).refs--, _.push(s);
        }

        e && v(w(e, l), l);

        for (t = 0; t < _.length; t++) {
          var s;

          if (0 === (s = _[t]).refs) {
            for (var c = 0; c < s.parts.length; c++) {
              s.parts[c]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var m,
        g = (m = [], function (e, l) {
      return m[e] = l, m.filter(Boolean).join("\n");
    });

    function y(e, l, a, _) {
      var t = a ? "" : _.css;
      if (e.styleSheet) e.styleSheet.cssText = g(l, t);else {
        var r = document.createTextNode(t),
            o = e.childNodes;
        o[l] && e.removeChild(o[l]), o.length ? e.insertBefore(r, o[l]) : e.appendChild(r);
      }
    }

    function x(e, l) {
      var a = l.css,
          _ = l.media;
      if (_ && e.setAttribute("media", _), e.styleSheet) e.styleSheet.cssText = a;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(a));
      }
    }

    function M(e, l, a) {
      var _ = a.css,
          t = a.sourceMap,
          r = void 0 === l.convertToAbsoluteUrls && t;
      (l.convertToAbsoluteUrls || r) && (_ = i(_)), t && (_ += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */");
      var o = new Blob([_], {
        type: "text/css"
      }),
          s = e.href;
      e.href = URL.createObjectURL(o), s && URL.revokeObjectURL(s);
    }
  }, function (e, l, a) {
    var _a = a(15),
        _ = _a.TableConstructor,
        t = {
      Toolbox: a(8),
      InsertColBefore: a(9),
      InsertColAfter: a(10),
      InsertRowBefore: a(11),
      InsertRowAfter: a(12),
      DeleteRow: a(13),
      DeleteCol: a(14)
    },
        r = "tc-table__inp";

    e.exports = /*#__PURE__*/function () {
      function _class(_ref) {
        var e = _ref.data,
            l = _ref.config,
            a = _ref.api;

        _classCallCheck(this, _class);

        this.api = a, this.wrapper = void 0, this.config = l, this.data = e, this._tableConstructor = new _(e, l, a), this.actions = [{
          actionName: "InsertColBefore",
          icon: t.InsertColBefore,
          label: "Insert column before"
        }, {
          actionName: "InsertColAfter",
          icon: t.InsertColAfter,
          label: "Insert column after"
        }, {
          actionName: "InsertRowBefore",
          icon: t.InsertRowBefore,
          label: "Insert row before"
        }, {
          actionName: "InsertRowAfter",
          icon: t.InsertRowAfter,
          label: "Insert row after"
        }, {
          actionName: "DeleteRow",
          icon: t.DeleteRow,
          label: "Delete row"
        }, {
          actionName: "DeleteCol",
          icon: t.DeleteCol,
          label: "Delete column"
        }];
      }

      _createClass(_class, [{
        key: "performAction",
        value: function performAction(e) {
          switch (e) {
            case "InsertColBefore":
              this._tableConstructor.table.insertColumnBefore();

              break;

            case "InsertColAfter":
              this._tableConstructor.table.insertColumnAfter();

              break;

            case "InsertRowBefore":
              this._tableConstructor.table.insertRowBefore();

              break;

            case "InsertRowAfter":
              this._tableConstructor.table.insertRowAfter();

              break;

            case "DeleteRow":
              this._tableConstructor.table.deleteRow();

              break;

            case "DeleteCol":
              this._tableConstructor.table.deleteColumn();

          }
        }
      }, {
        key: "renderSettings",
        value: function renderSettings() {
          var _this = this;

          var e = document.createElement("div");
          return this.actions.forEach(function (_ref2) {
            var l = _ref2.actionName,
                a = _ref2.label,
                _ = _ref2.icon;

            var t = _this.api.i18n.t(a),
                r = document.createElement("div");

            r.classList.add("cdx-settings-button"), r.innerHTML = _, r.title = l, _this.api.tooltip.onHover(r, t, {
              placement: "top"
            }), r.addEventListener("click", _this.performAction.bind(_this, l)), e.appendChild(r), _this._tableConstructor.table.selectedCell && _this._tableConstructor.table.focusCellOnSelectedCell();
          }), e;
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          if (this.wrapper = document.createElement("div"), this.data && this.data.content) this._createTableConfiguration();else {
            this.wrapper.classList.add("table-selector"), this.wrapper.setAttribute("data-hoveredClass", "m,n");
            var _e = 6;
            this.createCells(_e), "table-selector" === this.wrapper.className && this.wrapper.addEventListener("mouseover", function (e) {
              if (e.target.id.length) {
                var _l = e.target.attributes.row.value,
                    _a2 = e.target.attributes.column.value;

                _this2.wrapper.setAttribute("data-hoveredClass", "".concat(_l, ",").concat(_a2));
              }
            }), this.wrapper.addEventListener("click", function (e) {
              if (e.target.id.length) {
                var _l2 = e.target.attributes.row.value,
                    _a3 = e.target.attributes.column.value;
                _this2.wrapper.removeEventListener("mouseover", function () {}), _this2.config.rows = _l2, _this2.config.cols = _a3, _this2._createTableConfiguration();
              }
            });
          }
          return this.wrapper;
        }
      }, {
        key: "createCells",
        value: function createCells(e) {
          if (0 !== e) for (var _l3 = 0; _l3 < e; _l3++) {
            var _a4 = document.createElement("div");

            _a4.setAttribute("class", "table-row");

            for (var _2 = 0; _2 < e; _2++) {
              var _e2 = document.createElement("div"),
                  _t = document.createElement("div");

              _e2.setAttribute("class", "table-cell-container"), _t.setAttribute("class", "table-cell"), _e2.setAttribute("id", "row_".concat(_l3 + 1, "_cell_").concat(_2 + 1)), _e2.setAttribute("column", _2 + 1), _e2.setAttribute("row", _l3 + 1), _t.setAttribute("id", "cell_" + (_2 + 1)), _t.setAttribute("column", _2 + 1), _t.setAttribute("row", _l3 + 1), _e2.appendChild(_t), _a4.appendChild(_e2);
            }

            this.wrapper.appendChild(_a4);
          }
          var l = document.createElement("input");
          l.classList.add("hidden-element"), l.setAttribute("tabindex", 0), this.wrapper.appendChild(l);
        }
      }, {
        key: "_createTableConfiguration",
        value: function _createTableConfiguration() {
          this.wrapper.innerHTML = "", this._tableConstructor = new _(this.data, this.config, this.api), this.wrapper.appendChild(this._tableConstructor.htmlElement);
        }
      }, {
        key: "save",
        value: function save(e) {
          var l = e.querySelector("table"),
              a = [],
              _ = l ? l.rows : 0;

          if (_.length) {
            for (var _e3 = 0; _e3 < _.length; _e3++) {
              var _l4 = _[_e3],
                  _t2 = Array.from(_l4.cells).map(function (e) {
                return e.querySelector("." + r);
              });

              _t2.every(this._isEmpty) || a.push(_t2.map(function (e) {
                return e.innerHTML;
              }));
            }

            return {
              content: a
            };
          }
        }
      }, {
        key: "_isEmpty",
        value: function _isEmpty(e) {
          return !e.textContent.trim();
        }
      }, {
        key: "onPaste",
        value: function () {
          var _onPaste = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
            var l;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    l = e.detail.data;
                    this.data = this.pasteHandler(l), this._createTableConfiguration();

                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function onPaste(_x) {
            return _onPaste.apply(this, arguments);
          }

          return onPaste;
        }()
      }, {
        key: "pasteHandler",
        value: function pasteHandler(e) {
          var l = e.tagName,
              a = {
            content: [],
            config: {
              rows: 0,
              cols: 0
            }
          };

          if ("TABLE" === l) {
            var _l5 = Array.from(e.childNodes);

            _l5 = _l5.find(function (e) {
              return "TBODY" === e.nodeName;
            });

            var _3 = Array.from(_l5.childNodes);

            _3 = [_3].map(function (e) {
              return e.filter(function (e) {
                return "TR" === e.nodeName;
              });
            }), a.config.rows = _3[0].length, a.content = _3[0].map(function (e) {
              var l = e.childNodes;
              return a.config.cols = l.length, l = _toConsumableArray(l).map(function (e) {
                return e.innerHTML;
              }), l;
            });
          }

          return a;
        }
      }], [{
        key: "enableLineBreaks",
        get: function get() {
          return !0;
        }
      }, {
        key: "toolbox",
        get: function get() {
          return {
            icon: t.Toolbox,
            title: "Table"
          };
        }
      }, {
        key: "pasteConfig",
        get: function get() {
          return {
            tags: ["TABLE", "TR", "TD", "TBODY", "TH"]
          };
        }
      }]);

      return _class;
    }();
  }, function (e, l, a) {
    var _ = a(4);

    "string" == typeof _ && (_ = [[e.i, _, ""]]);
    var t = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    a(1)(_, t);
    _.locals && (e.exports = _.locals);
  }, function (e, l, a) {
    (e.exports = a(0)(!1)).push([e.i, ".tc-editor{padding:10px;position:relative;box-sizing:content-box;width:100%;left:-10px}", ""]);
  }, function (e, l) {
    e.exports = function (e) {
      var l = "undefined" != typeof window && window.location;
      if (!l) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;

      var a = l.protocol + "//" + l.host,
          _ = a + l.pathname.replace(/\/[^\/]*$/, "/");

      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, l) {
        var t,
            r = l.trim().replace(/^"(.*)"$/, function (e, l) {
          return l;
        }).replace(/^'(.*)'$/, function (e, l) {
          return l;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r) ? e : (t = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? a + r : _ + r.replace(/^\.\//, ""), "url(" + JSON.stringify(t) + ")");
      });
    };
  }, function (e, l, a) {
    var _ = a(7);

    "string" == typeof _ && (_ = [[e.i, _, ""]]);
    var t = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    a(1)(_, t);
    _.locals && (e.exports = _.locals);
  }, function (e, l, a) {
    (e.exports = a(0)(!1)).push([e.i, '.tc-table{width:100%;height:100%;border-collapse:collapse;table-layout:fixed;}.tc-table__wrap{border:1px solid #dbdbe2;border-radius:3px;position:relative;height:100%;width:100%;box-sizing:border-box}.tc-table__cell{border:1px solid #dbdbe2;padding:0;vertical-align:top}.tc-table__area{padding:10px;height:100%}.tc-table__inp{outline:none;flex-grow:100;min-height:1.5em;height:100%;overflow:hidden}.tc-table__highlight:focus-within{background-color:rgba(173,164,176,.1)}.tc-table tbody tr:first-child td{border-top:none}.tc-table tbody tr:last-child td{border-bottom:none}.tc-table tbody tr td:last-child{border-right:none}.tc-table tbody tr td:first-child{border-left:none}.table-selector{display:flex;flex-direction:column;}.table-selector .hidden-element{display:none}.table-row{display:flex;flex-direction:row}.table-cell-container{width:30px;height:30px}.table-cell{width:25px;height:25px;background:#f6f6f6;border:1px solid #e4e4e4;cursor:pointer}[data-hoveredClass="1,1"] #row_1_cell_1 #cell_1,[data-hoveredClass="1,2"] #row_1_cell_1 #cell_1,[data-hoveredClass="1,2"] #row_1_cell_2 #cell_2,[data-hoveredClass="1,3"] #row_1_cell_1 #cell_1,[data-hoveredClass="1,3"] #row_1_cell_2 #cell_2,[data-hoveredClass="1,3"] #row_1_cell_3 #cell_3,[data-hoveredClass="1,4"] #row_1_cell_1 #cell_1,[data-hoveredClass="1,4"] #row_1_cell_2 #cell_2,[data-hoveredClass="1,4"] #row_1_cell_3 #cell_3,[data-hoveredClass="1,4"] #row_1_cell_4 #cell_4,[data-hoveredClass="1,5"] #row_1_cell_1 #cell_1,[data-hoveredClass="1,5"] #row_1_cell_2 #cell_2,[data-hoveredClass="1,5"] #row_1_cell_3 #cell_3,[data-hoveredClass="1,5"] #row_1_cell_4 #cell_4,[data-hoveredClass="1,5"] #row_1_cell_5 #cell_5,[data-hoveredClass="1,6"] #row_1_cell_1 #cell_1,[data-hoveredClass="1,6"] #row_1_cell_2 #cell_2,[data-hoveredClass="1,6"] #row_1_cell_3 #cell_3,[data-hoveredClass="1,6"] #row_1_cell_4 #cell_4,[data-hoveredClass="1,6"] #row_1_cell_5 #cell_5,[data-hoveredClass="1,6"] #row_1_cell_6 #cell_6,[data-hoveredClass="2,1"] #row_1_cell_1 #cell_1,[data-hoveredClass="2,1"] #row_2_cell_1 #cell_1,[data-hoveredClass="2,2"] #row_1_cell_1 #cell_1,[data-hoveredClass="2,2"] #row_1_cell_2 #cell_2,[data-hoveredClass="2,2"] #row_2_cell_1 #cell_1,[data-hoveredClass="2,2"] #row_2_cell_2 #cell_2,[data-hoveredClass="2,3"] #row_1_cell_1 #cell_1,[data-hoveredClass="2,3"] #row_1_cell_2 #cell_2,[data-hoveredClass="2,3"] #row_1_cell_3 #cell_3,[data-hoveredClass="2,3"] #row_2_cell_1 #cell_1,[data-hoveredClass="2,3"] #row_2_cell_2 #cell_2,[data-hoveredClass="2,3"] #row_2_cell_3 #cell_3,[data-hoveredClass="2,4"] #row_1_cell_1 #cell_1,[data-hoveredClass="2,4"] #row_1_cell_2 #cell_2,[data-hoveredClass="2,4"] #row_1_cell_3 #cell_3,[data-hoveredClass="2,4"] #row_1_cell_4 #cell_4,[data-hoveredClass="2,4"] #row_2_cell_1 #cell_1,[data-hoveredClass="2,4"] #row_2_cell_2 #cell_2,[data-hoveredClass="2,4"] #row_2_cell_3 #cell_3,[data-hoveredClass="2,4"] #row_2_cell_4 #cell_4,[data-hoveredClass="2,5"] #row_1_cell_1 #cell_1,[data-hoveredClass="2,5"] #row_1_cell_2 #cell_2,[data-hoveredClass="2,5"] #row_1_cell_3 #cell_3,[data-hoveredClass="2,5"] #row_1_cell_4 #cell_4,[data-hoveredClass="2,5"] #row_1_cell_5 #cell_5,[data-hoveredClass="2,5"] #row_2_cell_1 #cell_1,[data-hoveredClass="2,5"] #row_2_cell_2 #cell_2,[data-hoveredClass="2,5"] #row_2_cell_3 #cell_3,[data-hoveredClass="2,5"] #row_2_cell_4 #cell_4,[data-hoveredClass="2,5"] #row_2_cell_5 #cell_5,[data-hoveredClass="2,6"] #row_1_cell_1 #cell_1,[data-hoveredClass="2,6"] #row_1_cell_2 #cell_2,[data-hoveredClass="2,6"] #row_1_cell_3 #cell_3,[data-hoveredClass="2,6"] #row_1_cell_4 #cell_4,[data-hoveredClass="2,6"] #row_1_cell_5 #cell_5,[data-hoveredClass="2,6"] #row_1_cell_6 #cell_6,[data-hoveredClass="2,6"] #row_2_cell_1 #cell_1,[data-hoveredClass="2,6"] #row_2_cell_2 #cell_2,[data-hoveredClass="2,6"] #row_2_cell_3 #cell_3,[data-hoveredClass="2,6"] #row_2_cell_4 #cell_4,[data-hoveredClass="2,6"] #row_2_cell_5 #cell_5,[data-hoveredClass="2,6"] #row_2_cell_6 #cell_6,[data-hoveredClass="3,1"] #row_1_cell_1 #cell_1,[data-hoveredClass="3,1"] #row_2_cell_1 #cell_1,[data-hoveredClass="3,1"] #row_3_cell_1 #cell_1,[data-hoveredClass="3,2"] #row_1_cell_1 #cell_1,[data-hoveredClass="3,2"] #row_1_cell_2 #cell_2,[data-hoveredClass="3,2"] #row_2_cell_1 #cell_1,[data-hoveredClass="3,2"] #row_2_cell_2 #cell_2,[data-hoveredClass="3,2"] #row_3_cell_1 #cell_1,[data-hoveredClass="3,2"] #row_3_cell_2 #cell_2,[data-hoveredClass="3,3"] #row_1_cell_1 #cell_1,[data-hoveredClass="3,3"] #row_1_cell_2 #cell_2,[data-hoveredClass="3,3"] #row_1_cell_3 #cell_3,[data-hoveredClass="3,3"] #row_2_cell_1 #cell_1,[data-hoveredClass="3,3"] #row_2_cell_2 #cell_2,[data-hoveredClass="3,3"] #row_2_cell_3 #cell_3,[data-hoveredClass="3,3"] #row_3_cell_1 #cell_1,[data-hoveredClass="3,3"] #row_3_cell_2 #cell_2,[data-hoveredClass="3,3"] #row_3_cell_3 #cell_3,[data-hoveredClass="3,4"] #row_1_cell_1 #cell_1,[data-hoveredClass="3,4"] #row_1_cell_2 #cell_2,[data-hoveredClass="3,4"] #row_1_cell_3 #cell_3,[data-hoveredClass="3,4"] #row_1_cell_4 #cell_4,[data-hoveredClass="3,4"] #row_2_cell_1 #cell_1,[data-hoveredClass="3,4"] #row_2_cell_2 #cell_2,[data-hoveredClass="3,4"] #row_2_cell_3 #cell_3,[data-hoveredClass="3,4"] #row_2_cell_4 #cell_4,[data-hoveredClass="3,4"] #row_3_cell_1 #cell_1,[data-hoveredClass="3,4"] #row_3_cell_2 #cell_2,[data-hoveredClass="3,4"] #row_3_cell_3 #cell_3,[data-hoveredClass="3,4"] #row_3_cell_4 #cell_4,[data-hoveredClass="3,5"] #row_1_cell_1 #cell_1,[data-hoveredClass="3,5"] #row_1_cell_2 #cell_2,[data-hoveredClass="3,5"] #row_1_cell_3 #cell_3,[data-hoveredClass="3,5"] #row_1_cell_4 #cell_4,[data-hoveredClass="3,5"] #row_1_cell_5 #cell_5,[data-hoveredClass="3,5"] #row_2_cell_1 #cell_1,[data-hoveredClass="3,5"] #row_2_cell_2 #cell_2,[data-hoveredClass="3,5"] #row_2_cell_3 #cell_3,[data-hoveredClass="3,5"] #row_2_cell_4 #cell_4,[data-hoveredClass="3,5"] #row_2_cell_5 #cell_5,[data-hoveredClass="3,5"] #row_3_cell_1 #cell_1,[data-hoveredClass="3,5"] #row_3_cell_2 #cell_2,[data-hoveredClass="3,5"] #row_3_cell_3 #cell_3,[data-hoveredClass="3,5"] #row_3_cell_4 #cell_4,[data-hoveredClass="3,5"] #row_3_cell_5 #cell_5,[data-hoveredClass="3,6"] #row_1_cell_1 #cell_1,[data-hoveredClass="3,6"] #row_1_cell_2 #cell_2,[data-hoveredClass="3,6"] #row_1_cell_3 #cell_3,[data-hoveredClass="3,6"] #row_1_cell_4 #cell_4,[data-hoveredClass="3,6"] #row_1_cell_5 #cell_5,[data-hoveredClass="3,6"] #row_1_cell_6 #cell_6,[data-hoveredClass="3,6"] #row_2_cell_1 #cell_1,[data-hoveredClass="3,6"] #row_2_cell_2 #cell_2,[data-hoveredClass="3,6"] #row_2_cell_3 #cell_3,[data-hoveredClass="3,6"] #row_2_cell_4 #cell_4,[data-hoveredClass="3,6"] #row_2_cell_5 #cell_5,[data-hoveredClass="3,6"] #row_2_cell_6 #cell_6,[data-hoveredClass="3,6"] #row_3_cell_1 #cell_1,[data-hoveredClass="3,6"] #row_3_cell_2 #cell_2,[data-hoveredClass="3,6"] #row_3_cell_3 #cell_3,[data-hoveredClass="3,6"] #row_3_cell_4 #cell_4,[data-hoveredClass="3,6"] #row_3_cell_5 #cell_5,[data-hoveredClass="3,6"] #row_3_cell_6 #cell_6,[data-hoveredClass="4,1"] #row_1_cell_1 #cell_1,[data-hoveredClass="4,1"] #row_2_cell_1 #cell_1,[data-hoveredClass="4,1"] #row_3_cell_1 #cell_1,[data-hoveredClass="4,1"] #row_4_cell_1 #cell_1,[data-hoveredClass="4,2"] #row_1_cell_1 #cell_1,[data-hoveredClass="4,2"] #row_1_cell_2 #cell_2,[data-hoveredClass="4,2"] #row_2_cell_1 #cell_1,[data-hoveredClass="4,2"] #row_2_cell_2 #cell_2,[data-hoveredClass="4,2"] #row_3_cell_1 #cell_1,[data-hoveredClass="4,2"] #row_3_cell_2 #cell_2,[data-hoveredClass="4,2"] #row_4_cell_1 #cell_1,[data-hoveredClass="4,2"] #row_4_cell_2 #cell_2,[data-hoveredClass="4,3"] #row_1_cell_1 #cell_1,[data-hoveredClass="4,3"] #row_1_cell_2 #cell_2,[data-hoveredClass="4,3"] #row_1_cell_3 #cell_3,[data-hoveredClass="4,3"] #row_2_cell_1 #cell_1,[data-hoveredClass="4,3"] #row_2_cell_2 #cell_2,[data-hoveredClass="4,3"] #row_2_cell_3 #cell_3,[data-hoveredClass="4,3"] #row_3_cell_1 #cell_1,[data-hoveredClass="4,3"] #row_3_cell_2 #cell_2,[data-hoveredClass="4,3"] #row_3_cell_3 #cell_3,[data-hoveredClass="4,3"] #row_4_cell_1 #cell_1,[data-hoveredClass="4,3"] #row_4_cell_2 #cell_2,[data-hoveredClass="4,3"] #row_4_cell_3 #cell_3,[data-hoveredClass="4,4"] #row_1_cell_1 #cell_1,[data-hoveredClass="4,4"] #row_1_cell_2 #cell_2,[data-hoveredClass="4,4"] #row_1_cell_3 #cell_3,[data-hoveredClass="4,4"] #row_1_cell_4 #cell_4,[data-hoveredClass="4,4"] #row_2_cell_1 #cell_1,[data-hoveredClass="4,4"] #row_2_cell_2 #cell_2,[data-hoveredClass="4,4"] #row_2_cell_3 #cell_3,[data-hoveredClass="4,4"] #row_2_cell_4 #cell_4,[data-hoveredClass="4,4"] #row_3_cell_1 #cell_1,[data-hoveredClass="4,4"] #row_3_cell_2 #cell_2,[data-hoveredClass="4,4"] #row_3_cell_3 #cell_3,[data-hoveredClass="4,4"] #row_3_cell_4 #cell_4,[data-hoveredClass="4,4"] #row_4_cell_1 #cell_1,[data-hoveredClass="4,4"] #row_4_cell_2 #cell_2,[data-hoveredClass="4,4"] #row_4_cell_3 #cell_3,[data-hoveredClass="4,4"] #row_4_cell_4 #cell_4,[data-hoveredClass="4,5"] #row_1_cell_1 #cell_1,[data-hoveredClass="4,5"] #row_1_cell_2 #cell_2,[data-hoveredClass="4,5"] #row_1_cell_3 #cell_3,[data-hoveredClass="4,5"] #row_1_cell_4 #cell_4,[data-hoveredClass="4,5"] #row_1_cell_5 #cell_5,[data-hoveredClass="4,5"] #row_2_cell_1 #cell_1,[data-hoveredClass="4,5"] #row_2_cell_2 #cell_2,[data-hoveredClass="4,5"] #row_2_cell_3 #cell_3,[data-hoveredClass="4,5"] #row_2_cell_4 #cell_4,[data-hoveredClass="4,5"] #row_2_cell_5 #cell_5,[data-hoveredClass="4,5"] #row_3_cell_1 #cell_1,[data-hoveredClass="4,5"] #row_3_cell_2 #cell_2,[data-hoveredClass="4,5"] #row_3_cell_3 #cell_3,[data-hoveredClass="4,5"] #row_3_cell_4 #cell_4,[data-hoveredClass="4,5"] #row_3_cell_5 #cell_5,[data-hoveredClass="4,5"] #row_4_cell_1 #cell_1,[data-hoveredClass="4,5"] #row_4_cell_2 #cell_2,[data-hoveredClass="4,5"] #row_4_cell_3 #cell_3,[data-hoveredClass="4,5"] #row_4_cell_4 #cell_4,[data-hoveredClass="4,5"] #row_4_cell_5 #cell_5,[data-hoveredClass="4,6"] #row_1_cell_1 #cell_1,[data-hoveredClass="4,6"] #row_1_cell_2 #cell_2,[data-hoveredClass="4,6"] #row_1_cell_3 #cell_3,[data-hoveredClass="4,6"] #row_1_cell_4 #cell_4,[data-hoveredClass="4,6"] #row_1_cell_5 #cell_5,[data-hoveredClass="4,6"] #row_1_cell_6 #cell_6,[data-hoveredClass="4,6"] #row_2_cell_1 #cell_1,[data-hoveredClass="4,6"] #row_2_cell_2 #cell_2,[data-hoveredClass="4,6"] #row_2_cell_3 #cell_3,[data-hoveredClass="4,6"] #row_2_cell_4 #cell_4,[data-hoveredClass="4,6"] #row_2_cell_5 #cell_5,[data-hoveredClass="4,6"] #row_2_cell_6 #cell_6,[data-hoveredClass="4,6"] #row_3_cell_1 #cell_1,[data-hoveredClass="4,6"] #row_3_cell_2 #cell_2,[data-hoveredClass="4,6"] #row_3_cell_3 #cell_3,[data-hoveredClass="4,6"] #row_3_cell_4 #cell_4,[data-hoveredClass="4,6"] #row_3_cell_5 #cell_5,[data-hoveredClass="4,6"] #row_3_cell_6 #cell_6,[data-hoveredClass="4,6"] #row_4_cell_1 #cell_1,[data-hoveredClass="4,6"] #row_4_cell_2 #cell_2,[data-hoveredClass="4,6"] #row_4_cell_3 #cell_3,[data-hoveredClass="4,6"] #row_4_cell_4 #cell_4,[data-hoveredClass="4,6"] #row_4_cell_5 #cell_5,[data-hoveredClass="4,6"] #row_4_cell_6 #cell_6,[data-hoveredClass="5,1"] #row_1_cell_1 #cell_1,[data-hoveredClass="5,1"] #row_2_cell_1 #cell_1,[data-hoveredClass="5,1"] #row_3_cell_1 #cell_1,[data-hoveredClass="5,1"] #row_4_cell_1 #cell_1,[data-hoveredClass="5,1"] #row_5_cell_1 #cell_1,[data-hoveredClass="5,2"] #row_1_cell_1 #cell_1,[data-hoveredClass="5,2"] #row_1_cell_2 #cell_2,[data-hoveredClass="5,2"] #row_2_cell_1 #cell_1,[data-hoveredClass="5,2"] #row_2_cell_2 #cell_2,[data-hoveredClass="5,2"] #row_3_cell_1 #cell_1,[data-hoveredClass="5,2"] #row_3_cell_2 #cell_2,[data-hoveredClass="5,2"] #row_4_cell_1 #cell_1,[data-hoveredClass="5,2"] #row_4_cell_2 #cell_2,[data-hoveredClass="5,2"] #row_5_cell_1 #cell_1,[data-hoveredClass="5,2"] #row_5_cell_2 #cell_2,[data-hoveredClass="5,3"] #row_1_cell_1 #cell_1,[data-hoveredClass="5,3"] #row_1_cell_2 #cell_2,[data-hoveredClass="5,3"] #row_1_cell_3 #cell_3,[data-hoveredClass="5,3"] #row_2_cell_1 #cell_1,[data-hoveredClass="5,3"] #row_2_cell_2 #cell_2,[data-hoveredClass="5,3"] #row_2_cell_3 #cell_3,[data-hoveredClass="5,3"] #row_3_cell_1 #cell_1,[data-hoveredClass="5,3"] #row_3_cell_2 #cell_2,[data-hoveredClass="5,3"] #row_3_cell_3 #cell_3,[data-hoveredClass="5,3"] #row_4_cell_1 #cell_1,[data-hoveredClass="5,3"] #row_4_cell_2 #cell_2,[data-hoveredClass="5,3"] #row_4_cell_3 #cell_3,[data-hoveredClass="5,3"] #row_5_cell_1 #cell_1,[data-hoveredClass="5,3"] #row_5_cell_2 #cell_2,[data-hoveredClass="5,3"] #row_5_cell_3 #cell_3,[data-hoveredClass="5,4"] #row_1_cell_1 #cell_1,[data-hoveredClass="5,4"] #row_1_cell_2 #cell_2,[data-hoveredClass="5,4"] #row_1_cell_3 #cell_3,[data-hoveredClass="5,4"] #row_1_cell_4 #cell_4,[data-hoveredClass="5,4"] #row_2_cell_1 #cell_1,[data-hoveredClass="5,4"] #row_2_cell_2 #cell_2,[data-hoveredClass="5,4"] #row_2_cell_3 #cell_3,[data-hoveredClass="5,4"] #row_2_cell_4 #cell_4,[data-hoveredClass="5,4"] #row_3_cell_1 #cell_1,[data-hoveredClass="5,4"] #row_3_cell_2 #cell_2,[data-hoveredClass="5,4"] #row_3_cell_3 #cell_3,[data-hoveredClass="5,4"] #row_3_cell_4 #cell_4,[data-hoveredClass="5,4"] #row_4_cell_1 #cell_1,[data-hoveredClass="5,4"] #row_4_cell_2 #cell_2,[data-hoveredClass="5,4"] #row_4_cell_3 #cell_3,[data-hoveredClass="5,4"] #row_4_cell_4 #cell_4,[data-hoveredClass="5,4"] #row_5_cell_1 #cell_1,[data-hoveredClass="5,4"] #row_5_cell_2 #cell_2,[data-hoveredClass="5,4"] #row_5_cell_3 #cell_3,[data-hoveredClass="5,4"] #row_5_cell_4 #cell_4,[data-hoveredClass="5,5"] #row_1_cell_1 #cell_1,[data-hoveredClass="5,5"] #row_1_cell_2 #cell_2,[data-hoveredClass="5,5"] #row_1_cell_3 #cell_3,[data-hoveredClass="5,5"] #row_1_cell_4 #cell_4,[data-hoveredClass="5,5"] #row_1_cell_5 #cell_5,[data-hoveredClass="5,5"] #row_2_cell_1 #cell_1,[data-hoveredClass="5,5"] #row_2_cell_2 #cell_2,[data-hoveredClass="5,5"] #row_2_cell_3 #cell_3,[data-hoveredClass="5,5"] #row_2_cell_4 #cell_4,[data-hoveredClass="5,5"] #row_2_cell_5 #cell_5,[data-hoveredClass="5,5"] #row_3_cell_1 #cell_1,[data-hoveredClass="5,5"] #row_3_cell_2 #cell_2,[data-hoveredClass="5,5"] #row_3_cell_3 #cell_3,[data-hoveredClass="5,5"] #row_3_cell_4 #cell_4,[data-hoveredClass="5,5"] #row_3_cell_5 #cell_5,[data-hoveredClass="5,5"] #row_4_cell_1 #cell_1,[data-hoveredClass="5,5"] #row_4_cell_2 #cell_2,[data-hoveredClass="5,5"] #row_4_cell_3 #cell_3,[data-hoveredClass="5,5"] #row_4_cell_4 #cell_4,[data-hoveredClass="5,5"] #row_4_cell_5 #cell_5,[data-hoveredClass="5,5"] #row_5_cell_1 #cell_1,[data-hoveredClass="5,5"] #row_5_cell_2 #cell_2,[data-hoveredClass="5,5"] #row_5_cell_3 #cell_3,[data-hoveredClass="5,5"] #row_5_cell_4 #cell_4,[data-hoveredClass="5,5"] #row_5_cell_5 #cell_5,[data-hoveredClass="5,6"] #row_1_cell_1 #cell_1,[data-hoveredClass="5,6"] #row_1_cell_2 #cell_2,[data-hoveredClass="5,6"] #row_1_cell_3 #cell_3,[data-hoveredClass="5,6"] #row_1_cell_4 #cell_4,[data-hoveredClass="5,6"] #row_1_cell_5 #cell_5,[data-hoveredClass="5,6"] #row_1_cell_6 #cell_6,[data-hoveredClass="5,6"] #row_2_cell_1 #cell_1,[data-hoveredClass="5,6"] #row_2_cell_2 #cell_2,[data-hoveredClass="5,6"] #row_2_cell_3 #cell_3,[data-hoveredClass="5,6"] #row_2_cell_4 #cell_4,[data-hoveredClass="5,6"] #row_2_cell_5 #cell_5,[data-hoveredClass="5,6"] #row_2_cell_6 #cell_6,[data-hoveredClass="5,6"] #row_3_cell_1 #cell_1,[data-hoveredClass="5,6"] #row_3_cell_2 #cell_2,[data-hoveredClass="5,6"] #row_3_cell_3 #cell_3,[data-hoveredClass="5,6"] #row_3_cell_4 #cell_4,[data-hoveredClass="5,6"] #row_3_cell_5 #cell_5,[data-hoveredClass="5,6"] #row_3_cell_6 #cell_6,[data-hoveredClass="5,6"] #row_4_cell_1 #cell_1,[data-hoveredClass="5,6"] #row_4_cell_2 #cell_2,[data-hoveredClass="5,6"] #row_4_cell_3 #cell_3,[data-hoveredClass="5,6"] #row_4_cell_4 #cell_4,[data-hoveredClass="5,6"] #row_4_cell_5 #cell_5,[data-hoveredClass="5,6"] #row_4_cell_6 #cell_6,[data-hoveredClass="5,6"] #row_5_cell_1 #cell_1,[data-hoveredClass="5,6"] #row_5_cell_2 #cell_2,[data-hoveredClass="5,6"] #row_5_cell_3 #cell_3,[data-hoveredClass="5,6"] #row_5_cell_4 #cell_4,[data-hoveredClass="5,6"] #row_5_cell_5 #cell_5,[data-hoveredClass="5,6"] #row_5_cell_6 #cell_6,[data-hoveredClass="6,1"] #row_1_cell_1 #cell_1,[data-hoveredClass="6,1"] #row_2_cell_1 #cell_1,[data-hoveredClass="6,1"] #row_3_cell_1 #cell_1,[data-hoveredClass="6,1"] #row_4_cell_1 #cell_1,[data-hoveredClass="6,1"] #row_5_cell_1 #cell_1,[data-hoveredClass="6,1"] #row_6_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_1_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_1_cell_2 #cell_2,[data-hoveredClass="6,2"] #row_2_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_2_cell_2 #cell_2,[data-hoveredClass="6,2"] #row_3_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_3_cell_2 #cell_2,[data-hoveredClass="6,2"] #row_4_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_4_cell_2 #cell_2,[data-hoveredClass="6,2"] #row_5_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_5_cell_2 #cell_2,[data-hoveredClass="6,2"] #row_6_cell_1 #cell_1,[data-hoveredClass="6,2"] #row_6_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_1_cell_1 #cell_1,[data-hoveredClass="6,3"] #row_1_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_1_cell_3 #cell_3,[data-hoveredClass="6,3"] #row_2_cell_1 #cell_1,[data-hoveredClass="6,3"] #row_2_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_2_cell_3 #cell_3,[data-hoveredClass="6,3"] #row_3_cell_1 #cell_1,[data-hoveredClass="6,3"] #row_3_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_3_cell_3 #cell_3,[data-hoveredClass="6,3"] #row_4_cell_1 #cell_1,[data-hoveredClass="6,3"] #row_4_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_4_cell_3 #cell_3,[data-hoveredClass="6,3"] #row_5_cell_1 #cell_1,[data-hoveredClass="6,3"] #row_5_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_5_cell_3 #cell_3,[data-hoveredClass="6,3"] #row_6_cell_1 #cell_1,[data-hoveredClass="6,3"] #row_6_cell_2 #cell_2,[data-hoveredClass="6,3"] #row_6_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_1_cell_1 #cell_1,[data-hoveredClass="6,4"] #row_1_cell_2 #cell_2,[data-hoveredClass="6,4"] #row_1_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_1_cell_4 #cell_4,[data-hoveredClass="6,4"] #row_2_cell_1 #cell_1,[data-hoveredClass="6,4"] #row_2_cell_2 #cell_2,[data-hoveredClass="6,4"] #row_2_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_2_cell_4 #cell_4,[data-hoveredClass="6,4"] #row_3_cell_1 #cell_1,[data-hoveredClass="6,4"] #row_3_cell_2 #cell_2,[data-hoveredClass="6,4"] #row_3_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_3_cell_4 #cell_4,[data-hoveredClass="6,4"] #row_4_cell_1 #cell_1,[data-hoveredClass="6,4"] #row_4_cell_2 #cell_2,[data-hoveredClass="6,4"] #row_4_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_4_cell_4 #cell_4,[data-hoveredClass="6,4"] #row_5_cell_1 #cell_1,[data-hoveredClass="6,4"] #row_5_cell_2 #cell_2,[data-hoveredClass="6,4"] #row_5_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_5_cell_4 #cell_4,[data-hoveredClass="6,4"] #row_6_cell_1 #cell_1,[data-hoveredClass="6,4"] #row_6_cell_2 #cell_2,[data-hoveredClass="6,4"] #row_6_cell_3 #cell_3,[data-hoveredClass="6,4"] #row_6_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_1_cell_1 #cell_1,[data-hoveredClass="6,5"] #row_1_cell_2 #cell_2,[data-hoveredClass="6,5"] #row_1_cell_3 #cell_3,[data-hoveredClass="6,5"] #row_1_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_1_cell_5 #cell_5,[data-hoveredClass="6,5"] #row_2_cell_1 #cell_1,[data-hoveredClass="6,5"] #row_2_cell_2 #cell_2,[data-hoveredClass="6,5"] #row_2_cell_3 #cell_3,[data-hoveredClass="6,5"] #row_2_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_2_cell_5 #cell_5,[data-hoveredClass="6,5"] #row_3_cell_1 #cell_1,[data-hoveredClass="6,5"] #row_3_cell_2 #cell_2,[data-hoveredClass="6,5"] #row_3_cell_3 #cell_3,[data-hoveredClass="6,5"] #row_3_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_3_cell_5 #cell_5,[data-hoveredClass="6,5"] #row_4_cell_1 #cell_1,[data-hoveredClass="6,5"] #row_4_cell_2 #cell_2,[data-hoveredClass="6,5"] #row_4_cell_3 #cell_3,[data-hoveredClass="6,5"] #row_4_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_4_cell_5 #cell_5,[data-hoveredClass="6,5"] #row_5_cell_1 #cell_1,[data-hoveredClass="6,5"] #row_5_cell_2 #cell_2,[data-hoveredClass="6,5"] #row_5_cell_3 #cell_3,[data-hoveredClass="6,5"] #row_5_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_5_cell_5 #cell_5,[data-hoveredClass="6,5"] #row_6_cell_1 #cell_1,[data-hoveredClass="6,5"] #row_6_cell_2 #cell_2,[data-hoveredClass="6,5"] #row_6_cell_3 #cell_3,[data-hoveredClass="6,5"] #row_6_cell_4 #cell_4,[data-hoveredClass="6,5"] #row_6_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_1_cell_1 #cell_1,[data-hoveredClass="6,6"] #row_1_cell_2 #cell_2,[data-hoveredClass="6,6"] #row_1_cell_3 #cell_3,[data-hoveredClass="6,6"] #row_1_cell_4 #cell_4,[data-hoveredClass="6,6"] #row_1_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_1_cell_6 #cell_6,[data-hoveredClass="6,6"] #row_2_cell_1 #cell_1,[data-hoveredClass="6,6"] #row_2_cell_2 #cell_2,[data-hoveredClass="6,6"] #row_2_cell_3 #cell_3,[data-hoveredClass="6,6"] #row_2_cell_4 #cell_4,[data-hoveredClass="6,6"] #row_2_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_2_cell_6 #cell_6,[data-hoveredClass="6,6"] #row_3_cell_1 #cell_1,[data-hoveredClass="6,6"] #row_3_cell_2 #cell_2,[data-hoveredClass="6,6"] #row_3_cell_3 #cell_3,[data-hoveredClass="6,6"] #row_3_cell_4 #cell_4,[data-hoveredClass="6,6"] #row_3_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_3_cell_6 #cell_6,[data-hoveredClass="6,6"] #row_4_cell_1 #cell_1,[data-hoveredClass="6,6"] #row_4_cell_2 #cell_2,[data-hoveredClass="6,6"] #row_4_cell_3 #cell_3,[data-hoveredClass="6,6"] #row_4_cell_4 #cell_4,[data-hoveredClass="6,6"] #row_4_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_4_cell_6 #cell_6,[data-hoveredClass="6,6"] #row_5_cell_1 #cell_1,[data-hoveredClass="6,6"] #row_5_cell_2 #cell_2,[data-hoveredClass="6,6"] #row_5_cell_3 #cell_3,[data-hoveredClass="6,6"] #row_5_cell_4 #cell_4,[data-hoveredClass="6,6"] #row_5_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_5_cell_6 #cell_6,[data-hoveredClass="6,6"] #row_6_cell_1 #cell_1,[data-hoveredClass="6,6"] #row_6_cell_2 #cell_2,[data-hoveredClass="6,6"] #row_6_cell_3 #cell_3,[data-hoveredClass="6,6"] #row_6_cell_4 #cell_4,[data-hoveredClass="6,6"] #row_6_cell_5 #cell_5,[data-hoveredClass="6,6"] #row_6_cell_6 #cell_6{background:#d5e4f9;border:1px solid #c0cffd}', ""]);
  }, function (e, l) {
    e.exports = '<svg width="18" height="14"><path d="M2.833 8v1.95a1.7 1.7 0 0 0 1.7 1.7h3.45V8h-5.15zm0-2h5.15V2.35h-3.45a1.7 1.7 0 0 0-1.7 1.7V6zm12.3 2h-5.15v3.65h3.45a1.7 1.7 0 0 0 1.7-1.7V8zm0-2V4.05a1.7 1.7 0 0 0-1.7-1.7h-3.45V6h5.15zM4.533.1h8.9a3.95 3.95 0 0 1 3.95 3.95v5.9a3.95 3.95 0 0 1-3.95 3.95h-8.9a3.95 3.95 0 0 1-3.95-3.95v-5.9A3.95 3.95 0 0 1 4.533.1z"></path></svg>';
  }, function (e, l) {
    e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-21 0 512 512" width="18" height="18"><path d="M181.332031 106.667969c-3.925781 0-7.828125-1.429688-10.921875-4.3125l-80-74.664063c-4.820312-4.480468-6.378906-11.457031-3.96875-17.558594C88.851562 4.011719 94.761719 0 101.332031 0h160c6.570313 0 12.480469 4.011719 14.871094 10.132812 2.410156 6.125.851563 13.078126-3.96875 17.558594l-80 74.664063c-3.070313 2.882812-6.976563 4.3125-10.902344 4.3125zM141.910156 32l39.421875 36.777344L220.757812 32zm0 0M90.667969 512H37.332031C16.746094 512 0 495.253906 0 474.667969V144c0-20.585938 16.746094-37.332031 37.332031-37.332031h53.335938C111.253906 106.667969 128 123.414062 128 144v330.667969C128 495.253906 111.253906 512 90.667969 512zM37.332031 138.667969C34.390625 138.667969 32 141.054688 32 144v330.667969C32 477.609375 34.390625 480 37.332031 480h53.335938C93.609375 480 96 477.609375 96 474.667969V144c0-2.945312-2.390625-5.332031-5.332031-5.332031zm0 0M432 512H272c-20.585938 0-37.332031-16.746094-37.332031-37.332031V144c0-20.585938 16.746093-37.332031 37.332031-37.332031h160c20.585938 0 37.332031 16.746093 37.332031 37.332031v330.667969C469.332031 495.253906 452.585938 512 432 512zM272 138.667969c-2.945312 0-5.332031 2.386719-5.332031 5.332031v330.667969C266.667969 477.609375 269.054688 480 272 480h160c2.945312 0 5.332031-2.390625 5.332031-5.332031V144c0-2.945312-2.386719-5.332031-5.332031-5.332031zm0 0"></path><path d="M112 325.332031H16c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h96c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0M453.332031 325.332031H250.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h202.664062c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path><path d="M352 512c-8.832031 0-16-7.167969-16-16V122.667969c0-8.832031 7.167969-16 16-16s16 7.167969 16 16V496c0 8.832031-7.167969 16-16 16zm0 0"></path></svg>';
  }, function (e, l) {
    e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-21 0 512 512" width="18" height="18"><path d="M288 106.667969c-3.925781 0-7.851562-1.429688-10.921875-4.3125l-80-74.664063c-4.800781-4.480468-6.378906-11.457031-3.96875-17.558594C195.519531 4.03125 201.429688 0 208 0h160c6.570312 0 12.480469 4.011719 14.890625 10.132812 2.410156 6.125.832031 13.078126-3.96875 17.558594l-80 74.664063c-3.070313 2.882812-6.996094 4.3125-10.921875 4.3125zM248.597656 32L288 68.777344 327.402344 32zm0 0M432 512h-53.332031c-20.589844 0-37.335938-16.746094-37.335938-37.332031V144c0-20.585938 16.746094-37.332031 37.335938-37.332031H432c20.585938 0 37.332031 16.746093 37.332031 37.332031v330.667969C469.332031 495.253906 452.585938 512 432 512zm-53.332031-373.332031c-2.945313 0-5.335938 2.386719-5.335938 5.332031v330.667969c0 2.941406 2.390625 5.332031 5.335938 5.332031H432c2.945312 0 5.332031-2.390625 5.332031-5.332031V144c0-2.945312-2.386719-5.332031-5.332031-5.332031zm0 0M197.332031 512h-160C16.746094 512 0 495.253906 0 474.667969V144c0-20.585938 16.746094-37.332031 37.332031-37.332031h160c20.589844 0 37.335938 16.746093 37.335938 37.332031v330.667969c0 20.585937-16.746094 37.332031-37.335938 37.332031zm-160-373.332031C34.390625 138.667969 32 141.054688 32 144v330.667969C32 477.609375 34.390625 480 37.332031 480h160c2.945313 0 5.335938-2.390625 5.335938-5.332031V144c0-2.945312-2.390625-5.332031-5.335938-5.332031zm0 0"></path><path d="M453.332031 325.332031h-96c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h96c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0M218.667969 325.332031H16c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h202.667969c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path><path d="M117.332031 512c-8.832031 0-16-7.167969-16-16V122.667969c0-8.832031 7.167969-16 16-16s16 7.167969 16 16V496c0 8.832031-7.167969 16-16 16zm0 0"></path></svg>';
  }, function (e, l) {
    e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -21 512 512" width="18" height="18"><path d="M16 277.332031c-1.984375 0-3.96875-.363281-5.867188-1.109375C4.011719 273.8125 0 267.902344 0 261.332031v-160c0-6.570312 4.011719-12.480469 10.132812-14.890625 6.144532-2.410156 13.078126-.851562 17.558594 3.96875l74.664063 80c5.761719 6.144532 5.761719 15.679688 0 21.824219l-74.664063 80C24.597656 275.5625 20.351562 277.332031 16 277.332031zm16-135.402343v78.804687l36.777344-39.402344zm0 0M474.667969 128H144c-20.585938 0-37.332031-16.746094-37.332031-37.332031V37.332031C106.667969 16.746094 123.414062 0 144 0h330.667969C495.253906 0 512 16.746094 512 37.332031v53.335938C512 111.253906 495.253906 128 474.667969 128zM144 32c-2.945312 0-5.332031 2.390625-5.332031 5.332031v53.335938C138.667969 93.609375 141.054688 96 144 96h330.667969C477.609375 96 480 93.609375 480 90.667969V37.332031C480 34.390625 477.609375 32 474.667969 32zm0 0M474.667969 469.332031H144c-20.585938 0-37.332031-16.746093-37.332031-37.332031V272c0-20.585938 16.746093-37.332031 37.332031-37.332031h330.667969C495.253906 234.667969 512 251.414062 512 272v160c0 20.585938-16.746094 37.332031-37.332031 37.332031zM144 266.667969c-2.945312 0-5.332031 2.386719-5.332031 5.332031v160c0 2.945312 2.386719 5.332031 5.332031 5.332031h330.667969C477.609375 437.332031 480 434.945312 480 432V272c0-2.945312-2.390625-5.332031-5.332031-5.332031zm0 0"></path><path d="M309.332031 128c-8.832031 0-16-7.167969-16-16V16c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v96c0 8.832031-7.167969 16-16 16zm0 0M309.332031 469.332031c-8.832031 0-16-7.167969-16-16V250.667969c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v202.664062c0 8.832031-7.167969 16-16 16zm0 0"></path><path d="M496 368H122.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16H496c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path></svg>';
  }, function (e, l) {
    e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -21 512 512" width="18" height="18"><path d="M16 384c-1.984375 0-3.96875-.363281-5.867188-1.109375C4.011719 380.480469 0 374.570312 0 368V208c0-6.570312 4.011719-12.480469 10.132812-14.890625 6.144532-2.410156 13.078126-.851563 17.558594 3.96875l74.664063 80c5.761719 6.144531 5.761719 15.679687 0 21.824219l-74.664063 80C24.597656 382.230469 20.351562 384 16 384zm16-135.402344v78.804688L68.777344 288zm0 0M474.667969 469.332031H144c-20.585938 0-37.332031-16.746093-37.332031-37.332031v-53.332031c0-20.589844 16.746093-37.335938 37.332031-37.335938h330.667969c20.585937 0 37.332031 16.746094 37.332031 37.335938V432c0 20.585938-16.746094 37.332031-37.332031 37.332031zm-330.667969-96c-2.945312 0-5.332031 2.390625-5.332031 5.335938V432c0 2.945312 2.386719 5.332031 5.332031 5.332031h330.667969C477.609375 437.332031 480 434.945312 480 432v-53.332031c0-2.945313-2.390625-5.335938-5.332031-5.335938zm0 0M474.667969 234.667969H144c-20.585938 0-37.332031-16.746094-37.332031-37.335938v-160C106.667969 16.746094 123.414062 0 144 0h330.667969C495.253906 0 512 16.746094 512 37.332031v160c0 20.589844-16.746094 37.335938-37.332031 37.335938zM144 32c-2.945312 0-5.332031 2.390625-5.332031 5.332031v160c0 2.945313 2.386719 5.335938 5.332031 5.335938h330.667969c2.941406 0 5.332031-2.390625 5.332031-5.335938v-160C480 34.390625 477.609375 32 474.667969 32zm0 0"></path><path d="M309.332031 469.332031c-8.832031 0-16-7.167969-16-16v-96c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v96c0 8.832031-7.167969 16-16 16zm0 0M309.332031 234.667969c-8.832031 0-16-7.167969-16-16V16c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v202.667969c0 8.832031-7.167969 16-16 16zm0 0"></path><path d="M496 133.332031H122.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16H496c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"></path></svg>';
  }, function (e, l) {
    e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.381 15.381" width="18" height="18"><g><path d="M0 1.732v7.732h6.053c0-.035-.004-.07-.004-.104 0-.434.061-.854.165-1.255H1.36V3.092h12.662v2.192c.546.396 1.01.897 1.359 1.477V1.732H0z"></path><path d="M11.196 5.28c-2.307 0-4.183 1.877-4.183 4.184 0 2.308 1.876 4.185 4.183 4.185 2.309 0 4.185-1.877 4.185-4.185 0-2.307-1.876-4.184-4.185-4.184zm0 7.233c-1.679 0-3.047-1.367-3.047-3.049 0-1.68 1.368-3.049 3.047-3.049 1.684 0 3.05 1.369 3.05 3.049 0 1.682-1.366 3.049-3.05 3.049z"></path><path d="M9.312 8.759h3.844v1.104H9.312z"></path></g></svg>';
  }, function (e, l) {
    e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="18" height="18"><path d="M13.594 20.85V24h-10V2h10v3.15c.633-.323 1.304-.565 2-.727V1c0-.551-.448-1-1-1h-12c-.55 0-1 .449-1 1v24c0 .551.449 1 1 1h12c.552 0 1-.449 1-1v-3.424c-.696-.161-1.367-.403-2-.726z"></path><path d="M17.594 6.188c-3.762 0-6.813 3.051-6.812 6.813-.001 3.761 3.05 6.812 6.812 6.812s6.813-3.051 6.813-6.813-3.052-6.812-6.813-6.812zm3.632 7.802l-7.267.001v-1.982h7.268l-.001 1.981z"></path></svg>';
  }, function (e, l, a) {
    "use strict";

    a.r(l), a.d(l, "TableConstructor", function () {
      return w;
    });
    a(3);

    function _(e) {
      return !(null == e);
    }

    function t(e) {
      var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var r = document.createElement(e);
      if (_(l)) for (var _e4 = 0; _e4 < l.length; _e4++) {
        _(l[_e4]) && r.classList.add(l[_e4]);
      }
      if (_(a)) for (var _e5 in a) {
        r.setAttribute(_e5, a[_e5]);
      }
      if (_(t)) for (var _e6 = 0; _e6 < t.length; _e6++) {
        _(t[_e6]) && r.appendChild(t[_e6]);
      }
      return r;
    }

    a(6);
    var r = "tc-table",
        o = "tc-table__inp",
        s = "tc-table__cell",
        c = "tc-table__wrap",
        d = "tc-table__area",
        h = "tc-table__highlight";

    var n = /*#__PURE__*/function () {
      function n() {
        _classCallCheck(this, n);

        this._numberOfColumns = 0, this._numberOfRows = 0, this._element = this._createTableWrapper(), this._table = this._element.querySelector("table"), this._selectedCell = null, this._attachEvents();
      }

      _createClass(n, [{
        key: "selectedCell",
        get: function get() {
          return this._selectedCell;
        },
        set: function set(e) {
          this._selectedCell && this._selectedCell.classList.remove(h), this._selectedCell = e, this._selectedCell && this._selectedCell.classList.add(h);
        }
      }, {
        key: "selectedRow",
        get: function get() {
          return this.selectedCell ? this.selectedCell.closest("tr") : null;
        }
      }, {
        key: "insertColumnAfter",
        value: function insertColumnAfter() {
          this.insertColumn(1), this.focusCellOnSelectedCell();
        }
      }, {
        key: "insertColumnBefore",
        value: function insertColumnBefore() {
          this.insertColumn(), this.focusCellOnSelectedCell();
        }
      }, {
        key: "insertRowBefore",
        value: function insertRowBefore() {
          this.insertRow(), this.focusCellOnSelectedCell();
        }
      }, {
        key: "insertRowAfter",
        value: function insertRowAfter() {
          this.insertRow(1), this.focusCellOnSelectedCell();
        }
      }, {
        key: "insertColumn",
        value: function insertColumn() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          e = Math.min(Math.max(e, 0), 1);
          var l = this.selectedCell ? this.selectedCell.cellIndex + e : 0;
          this._numberOfColumns++;
          var a = this._table.rows;

          for (var _e7 = 0; _e7 < a.length; _e7++) {
            var _4 = a[_e7].insertCell(l);

            this._fillCell(_4);
          }
        }
      }, {
        key: "deleteColumn",
        value: function deleteColumn() {
          if (!this.selectedCell) return;
          var e = this.selectedCell.cellIndex;
          this._numberOfColumns--;
          var l = this._table.rows;

          for (var _a5 = 0; _a5 < l.length; _a5++) {
            l[_a5].deleteCell(e);
          }
        }
      }, {
        key: "insertRow",
        value: function insertRow() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          e = Math.min(Math.max(e, 0), 1);

          var l = this.selectedRow ? this.selectedRow.rowIndex + e : 0,
              a = this._table.insertRow(l);

          return this._numberOfRows++, this._fillRow(a), a;
        }
      }, {
        key: "deleteRow",
        value: function deleteRow() {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
          if (!this.selectedRow) return;
          var l = this.selectedRow.rowIndex;
          this._table.deleteRow(l), this._numberOfRows--;
        }
      }, {
        key: "htmlElement",
        get: function get() {
          return this._element;
        }
      }, {
        key: "body",
        get: function get() {
          return this._table;
        }
      }, {
        key: "_createTableWrapper",
        value: function _createTableWrapper() {
          return t("div", [c], null, [t("table", [r])]);
        }
      }, {
        key: "_createContenteditableArea",
        value: function _createContenteditableArea() {
          return t("div", [o], {
            contenteditable: "true"
          });
        }
      }, {
        key: "_fillCell",
        value: function _fillCell(e) {
          e.classList.add(s);

          var l = this._createContenteditableArea();

          e.appendChild(t("div", [d], null, [l]));
        }
      }, {
        key: "_fillRow",
        value: function _fillRow(e) {
          for (var _l6 = 0; _l6 < this._numberOfColumns; _l6++) {
            var _l7 = e.insertCell();

            this._fillCell(_l7);
          }
        }
      }, {
        key: "_attachEvents",
        value: function _attachEvents() {
          var _this3 = this;

          this._table.addEventListener("focus", function (e) {
            _this3._focusEditField(e);
          }, !0), this._table.addEventListener("keydown", function (e) {
            _this3._pressedEnterInEditField(e);
          }), this._table.addEventListener("click", function (e) {
            _this3._clickedOnCell(e);
          }), this.htmlElement.addEventListener("keydown", function (e) {
            _this3._containerKeydown(e);
          });
        }
      }, {
        key: "_focusEditField",
        value: function _focusEditField(e) {
          this.selectedCell = "TD" === e.target.tagName ? e.target : e.target.closest("td");
        }
      }, {
        key: "focusCellOnSelectedCell",
        value: function focusCellOnSelectedCell() {
          this.selectedCell.childNodes[0].childNodes[0].focus();
        }
      }, {
        key: "_pressedEnterInEditField",
        value: function _pressedEnterInEditField(e) {
          e.target.classList.contains(o) && ("Enter" !== e.key || e.shiftKey || e.preventDefault());
        }
      }, {
        key: "_clickedOnCell",
        value: function _clickedOnCell(e) {
          if (!e.target.classList.contains(s)) return;
          e.target.querySelector("." + o).focus();
        }
      }, {
        key: "_containerKeydown",
        value: function _containerKeydown(e) {
          "Enter" === e.key && e.ctrlKey && this._containerEnterPressed(e);
        }
      }, {
        key: "_containerEnterPressed",
        value: function _containerEnterPressed(e) {
          this.insertRow(1).cells[0].click();
        }
      }]);

      return n;
    }();

    var i = "tc-editor",
        v = "tc-table__inp";

    var w = /*#__PURE__*/function () {
      function w(e, l, a) {
        _classCallCheck(this, w);

        this._table = new n();

        var _ = this._resizeTable(e, l);

        this._fillTable(e, _), this._container = t("div", [i, a.styles && a.styles.block], null, [this._table.htmlElement]);
      }

      _createClass(w, [{
        key: "htmlElement",
        get: function get() {
          return this._container;
        }
      }, {
        key: "table",
        get: function get() {
          return this._table;
        }
      }, {
        key: "_fillTable",
        value: function _fillTable(e, l) {
          if (void 0 !== e.content) for (var _a6 = 0; _a6 < l.rows && _a6 < e.content.length; _a6++) {
            for (var _5 = 0; _5 < l.cols && _5 < e.content[_a6].length; _5++) {
              this._table.body.rows[_a6].cells[_5].querySelector("." + v).innerHTML = e.content[_a6][_5];
            }
          }
        }
      }, {
        key: "_resizeTable",
        value: function _resizeTable(e, l) {
          var a = Array.isArray(e.content),
              _ = !!a && e.content.length,
              t = a ? e.content.length : void 0,
              r = _ ? e.content[0].length : void 0,
              o = Number.parseInt(l.rows),
              s = Number.parseInt(l.cols),
              c = !isNaN(o) && o > 0 ? o : void 0,
              d = !isNaN(s) && s > 0 ? s : void 0,
              h = t || c || 1,
              n = r || d || 1;

          for (var _e8 = 0; _e8 < h; _e8++) {
            this._table.insertRow();
          }

          for (var _e9 = 0; _e9 < n; _e9++) {
            this._table.insertColumn();
          }

          return {
            rows: h,
            cols: n
          };
        }
      }]);

      return w;
    }();
  }]);
});